import { ChangeDetectionStrategy, Component, inject, signal } from '@angular/core';
import { EmblaCarouselDirective } from 'embla-carousel-angular';
import AutoScroll from 'embla-carousel-auto-scroll';
import { FileUploadService } from '../../../core/file/file-upload.service';
import { PartnerDtoService } from '../../../dto/partner/partner-dto.service';
import { FileService } from '@szebit-app/sdk/backend';
import { map, switchMap } from 'rxjs';
import { FileToUrlPipe } from '@pct-ng/feature-image-native';
import { isSuccessFileUploadResponse } from '@pct-ng/feature-file-upload-native';
import { MatProgressSpinner } from '@angular/material/progress-spinner';

type PartnerLogo = { alt: string | null; file: File; website: string | null };

@Component({
  selector: 'app-partners',
  templateUrl: './partners.component.html',
  styleUrl: './partners.component.scss',
  imports: [EmblaCarouselDirective, FileToUrlPipe, MatProgressSpinner],
  providers: [FileService, FileUploadService, PartnerDtoService],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PartnersComponent {
  readonly #fileUploadService = inject(FileUploadService);
  protected service = inject(PartnerDtoService);

  protected partners: PartnerLogo[] | null = null;
  protected isLoading = signal(true);

  protected readonly plugins = [
    AutoScroll({
      playOnInit: true,
      stopOnMouseEnter: true,
      stopOnInteraction: false,
    }),
  ];

  constructor() {
    this.service
      .listPublic()
      .pipe(
        switchMap(partners =>
          this.#fileUploadService
            .getByIds(partners.map(p => p.logoId))
            .pipe(map(files => ({ partners, files }))),
        ),
      )
      .subscribe(({ partners, files }) => {
        const fileMap = new Map(
          files.filter(f => isSuccessFileUploadResponse(f)).map(f => [f.id, f.file]),
        );
        this.partners = partners.map(partner => ({
          alt: partner.name,
          file: fileMap.get(partner.logoId)!,
          website: partner.website,
        }));
        this.isLoading.set(false);
      });
  }
}
